module.exports = __webpack_public_path__ + "css/Ascot.9868cb53.css";